import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Serviceimg01 from '../../../assets/images/services/service-image-five.jpg';
import Serviceimg02 from '../../../assets/images/services/service-icon-five-1.svg';
import Serviceimg03 from '../../../assets/images/services/service-icon-five-2.svg';
import Serviceimg04 from '../../../assets/images/services/service-icon-five-3.svg';
import Serviceimg05 from '../../../assets/images/services/service-icon-five-4.svg';

const services = [
    {
        id: 1,
        image: Serviceimg02,
        title: "Business Analysis",
        description: "We guarantee to provide affordable business consulting solutions that help costs and improve your profits.",
    },
    {
        id: 2,
        image: Serviceimg03,
        title: "Work organization",
        description: "We stay up-to-date with the latest technology trends and offer innovative solutions that help you stay ahead.",
    },
    {
        id: 3,
        image: Serviceimg04,
        title: "Digital marketing",
        description: "We specialize in serving specific industries, such as healthcare manufacturing, and offer tailored solutions.",
    },
    {
        id: 4,
        image: Serviceimg05,
        title: "Innovation space",
        description: "Our solutions are scalable and can grow with your business you get the most value out of your investment.",
    },
    {
        id: 5,
        image: Serviceimg02,
        title: "Business Analysis",
        description: "We guarantee to provide affordable business consulting solutions that help costs and improve your profits.",
    }
];

const Servicesec = () => {
    const ServiceSlider = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        variableWidth: true
    };
    return (
        <>
            <div className="service-section-five">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 col-md-4">
                            <div className="service-image-five">
                                <img
                                    src={Serviceimg01}
                                    alt="service-image"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-8">
                            <div className="service-info-five">
                                <div className="heading-box light">
                                    <span
                                        className="sub-title-two animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        Services
                                    </span>
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        Exploring Business world through our Services
                                    </h2>
                                </div>
                                <p
                                    className="lead animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    At uniqo, we are a renowned global consulting firm committed to
                                    collaborating with business and societal leaders in overcoming their
                                    most critical challenges and seizing their greatest opportunities.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Slider className="service-slider-five" {...ServiceSlider}>
                        {services.map((Service) => (
                            <div key={Service.id} className="service-slider-item-five">
                                <div className="service-box-five">
                                    <div className="service-icon-five">
                                        <img
                                            src={Service.image}
                                            alt="icon"
                                        />
                                    </div>
                                    <h4>{Service.title}</h4>
                                    <p>
                                        {Service.description}
                                    </p>
                                    <Link to="/ServiceDetails" className="service-btn-one">
                                        <span>Read More</span>
                                        <i className="fa-solid fa-angle-right" />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </>
    )
}

export default Servicesec;
